import Descope from '@descope/web-js-sdk';

export const descope = Descope({
  projectId: window.runTimeEnvs.VITE_DESCOPE_PROJECT_ID,
  autoRefresh: true,
});
